import React from "react";
import { NavLink } from "react-router-dom";

const SettingsList = () => {

    return (
        <div className="container-fluid subscriptions-component">
            <div className="row">
                <div className="col">
                    <h1 className="title">Stillingar</h1>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <ul className="nav flex-column settings-nav">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/plangroups">{gettext('Plan groups')}</NavLink>
                        </li>
                        {/* <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/discounts">{gettext('Discount groups')}</NavLink>
                        </li> */}
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/paymentprocessors">{gettext('Payment processors')}</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/webhooks">{gettext('Webhooks')}</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/apikeys">{gettext('API keys')}</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/paymentbuttons">{gettext('Payment buttons')}</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/users">{gettext('Users')}</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/account">{gettext('Account details')}</NavLink>
                        </li>
                        {/* <li className="nav-item">
                            <NavLink className="nav-link" to="/settings/billing">{gettext('Billing')}</NavLink>
                        </li> */}
                    </ul>
                </div>
            </div>
        </div>
    )

}

export default SettingsList